"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATISTICS_CONFIG = void 0;
var react_1 = __importStar(require("react"));
var hy_am_1 = __importDefault(require("moment/locale/hy-am"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var statisticsSlice_1 = require("../../../features/statistics/statisticsSlice");
var BlDropdown_1 = __importDefault(require("../../FormComponents/BlDropdown"));
var react_router_dom_1 = require("react-router-dom");
var moment_1 = __importDefault(require("moment"));
var CardSkeleton_1 = __importDefault(require("./PostStatisticsSkeleton/CardSkeleton"));
var deviceHelper_1 = require("../../../helpers/deviceHelper");
var PostCode_1 = __importDefault(require("../../PostCode"));
var dateHelper_1 = require("../../../helpers/dateHelper");
var StatisticsChart_1 = __importDefault(require("../../StatisticsChart"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
exports.STATISTICS_CONFIG = {
    DEFAULT_OPTION: 'daily',
    OPTIONS: {
        MONTHLY: 'monthly',
        DAILY: 'daily',
    },
};
moment_1.default.updateLocale('hy-am', hy_am_1.default);
var Statistics = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var id = react_router_dom_1.useParams().id;
    var _a = react_1.useState(), post = _a[0], setPost = _a[1];
    var currentPost = react_redux_1.useSelector(statisticsSlice_1.selectCurrentStatisticsPost);
    var totalViews = react_redux_1.useSelector(statisticsSlice_1.statisticsTotalViewsSelector);
    var statisticsLoader = react_redux_1.useSelector(statisticsSlice_1.statisticsLoadingSelector);
    var dispatch = react_redux_1.useDispatch();
    var dropdownOptions = [
        {
            text: t("Account.STATISTICS.STATISTICS_FILTER." + exports.STATISTICS_CONFIG.OPTIONS.DAILY.toUpperCase()),
            value: exports.STATISTICS_CONFIG.OPTIONS.DAILY,
        },
        {
            text: t("Account.STATISTICS.STATISTICS_FILTER." + exports.STATISTICS_CONFIG.OPTIONS.MONTHLY.toUpperCase()),
            value: exports.STATISTICS_CONFIG.OPTIONS.MONTHLY,
        },
    ];
    react_1.useEffect(function () {
        setPost(currentPost);
    }, [currentPost]);
    react_1.useEffect(function () {
        dispatch(statisticsSlice_1.getPostStatistics(id, exports.STATISTICS_CONFIG.DEFAULT_OPTION));
        dispatch(statisticsSlice_1.getStatisticsPost(id));
        return function () {
            dispatch(statisticsSlice_1.removePostStatisticsData());
        };
    }, [id]);
    if (!post) {
        return react_1.default.createElement(CardSkeleton_1.default, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h1", null, t('Account.STATISTICS.STATISTICS')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.head },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.about },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.announcement_id },
                        react_1.default.createElement(PostCode_1.default, { code: post.publicCode })),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.post_data },
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.info },
                            react_1.default.createElement("span", null, t('Account.STATISTICS.PUBLISH_DATE')),
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.data },
                                react_1.default.createElement("i", { className: "cm-icon icon-calendar" }),
                                react_1.default.createElement("span", null, dateHelper_1.readableDate(post.publishedAt)))),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.info },
                            react_1.default.createElement("span", null, t('Account.STATISTICS.TOTAL_VIEWS')),
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.data },
                                react_1.default.createElement("i", { className: "cm-icon icon-view" }),
                                react_1.default.createElement("span", null, totalViews))))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.show },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.dropdown_zon },
                        react_1.default.createElement("span", { className: styles_module_scss_1.default.show_by },
                            t('Account.STATISTICS.SHOW'),
                            react_1.default.createElement("span", null, deviceHelper_1.isMobile() ? '' : ':')),
                        react_1.default.createElement(BlDropdown_1.default, { placeholder: dropdownOptions[0].text, disabled: statisticsLoader, icon: react_1.default.createElement("i", { className: 'icon-chevron-down' }), options: dropdownOptions, className: styles_module_scss_1.default.option_style, onChange: function (event, data) {
                                return dispatch(statisticsSlice_1.getPostStatistics(id, data.value));
                            } })))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bar },
                react_1.default.createElement(StatisticsChart_1.default, { totalViews: totalViews })))));
};
exports.default = Statistics;
